import { useCallback, useState } from 'react';

/**
 * Ориентация матрицы «критерии × предложения» в таблицах WinnerSelection:
 * - 'byCriteria' — строки = критерии (сгруппированы по категориям),
 *                  столбцы = предложения (исходный вид);
 * - 'byOffer'    — строки = предложения, столбцы = критерии (транспонированный).
 */
export type WinnerTableView = 'byCriteria' | 'byOffer';

const STORAGE_KEY = 'winnerSelection.tableView';
const DEFAULT_VIEW: WinnerTableView = 'byCriteria';

const isView = (v: string | null): v is WinnerTableView => v === 'byCriteria' || v === 'byOffer';

const readView = (): WinnerTableView => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return isView(raw) ? raw : DEFAULT_VIEW;
    } catch {
        return DEFAULT_VIEW;
    }
};

/**
 * Хранит выбранный вид таблицы и персистит его в localStorage. Ключ общий для
 * Demand- и KO-таблиц, поэтому выбор синхронен между ними между перемонтированиями.
 */
export function useTableViewMode(): readonly [WinnerTableView, (v: WinnerTableView) => void] {
    const [view, setViewState] = useState<WinnerTableView>(readView);

    const setView = useCallback((v: WinnerTableView) => {
        setViewState(v);
        try {
            localStorage.setItem(STORAGE_KEY, v);
        } catch {
            /* localStorage недоступен (приватный режим Safari и т.п.) */
        }
    }, []);

    return [view, setView] as const;
}
